import iotDeviceFeatureConfigService from '../../../../services/iotDevice/iotDeviceFeatureConfigService';
import deviceGlobalConfigService from '../../../../services/iotDevice/iotDeviceGlobalConfigService';
import iotDeviceSettingsService from '../../../../services/iotDevice/iotDeviceSettingsService';

const useCleaningModeEnabled = (iotDevice) => {
    const isGlobalSelfCleaning = deviceGlobalConfigService.isGlobalSelfCleaning(iotDevice);
    const isSelfCleaning = iotDeviceSettingsService.isSettingAvailable(
        iotDevice,
        isGlobalSelfCleaning,
        iotDeviceFeatureConfigService.isCleaningEnabled()
    );

    return isSelfCleaning;
};

export default useCleaningModeEnabled;
